import { withRouter } from 'react-router';
import TeamsTabs from './TeamsTabs';

export default withRouter(TeamsTabs);
